export default __webpack_public_path__ + "static/media/servicesbg.3f4910de.mp4";